<template>
  <div class="title-with-icon title-with-icon_menu mb-5">
    <div class="title-with-icon__icon title-with-icon__icon_back"></div>
    <div class="title-with-icon__title">
      <a :href="backLink">{{ backTitle }}</a>
    </div>
    <div class="title-with-icon__delimeter">/</div>
    <div class="title-with-icon__title">{{ currentTitle }}</div>
  </div>
</template>

<script>
export default {
  name: 'ContentPageHeader',
  props: {
    backLink: { type: String, required: true },
    backTitle: { type: String, required: true },
    currentTitle: { type: String, required: true },
  }
}
</script>
